
/* System defined core library */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined library */
import { SelectedExamDetailService } from '../../services/selected-exam-detail.service';

@Component({
  selector: 'app-payment-voucher-detail',
  templateUrl: './payment-voucher-detail.component.html',
  styleUrls: ['./payment-voucher-detail.component.scss']
})

export class PaymentVoucherDetailComponent implements OnInit {

  /* User defined private/public variables  */
  public voucherFrm: FormGroup;
  public voucherKey: string;
  public voucherAttempts: number;

  translateLanguage$: Subscription;
  voucherAttempts$: Subscription;

  /* Input-OutPut parameters decalartions */
  @Input() public initialVoucherNumber: string;
  @Input() public isVoucherValid: boolean;
  @Input() public voucherError: boolean;
  @Input() public disableInput: boolean;
  @Output() public isVoucherFormValid: EventEmitter<any> = new EventEmitter();
  @Output() public voucherFormDetail: EventEmitter<any> = new EventEmitter();
  @Output() public validateVoucher: EventEmitter<string> = new EventEmitter();

  /* Constructor declaration with required injected services */
  constructor(
    private fb: FormBuilder,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService
  ) {

    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      }
    );

    this.voucherAttempts$ = selectedExamDetailService.voucherAttempts.subscribe(
      voucherAttempts => {
        this.voucherAttempts = voucherAttempts;
      }
    );
  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit() {
    this.voucherFrm = this.fb.group({
      'voucherNumber': new FormControl('', null)
    });

    // emit the validity of the form on init
    let isAllFieldValid = this.checkFormValid();//validating for all field
    this.isVoucherFormValid.emit(isAllFieldValid);//Emitted paymentFrm valid state to parent

    if (!!this.initialVoucherNumber) {
      this.voucherFrm.controls['voucherNumber'].setValue(this.initialVoucherNumber);
    }

    this.voucherFrm.valueChanges.subscribe(() => {
      let isAllFieldValid = this.checkFormValid();//validating for all field
      this.isVoucherFormValid.emit(isAllFieldValid);//Emitted paymentFrm valid state to parent
      this.voucherKey = this.voucherFrm.controls["voucherNumber"].value.trim();
      this.voucherFormDetail.emit(this.voucherKey); //Emitted fill data to parent page for final Call
    });
  }

  isDisable(): boolean {
    return !this.voucherFrm.valid || !(this.voucherFrm.controls["voucherNumber"].value.trim()) || this.isVoucherValid || this.isLocked() || this.voucherError;
  }

  isLocked(): boolean {
    return (this.voucherAttempts >= this.selectedExamDetailService.voucherAttemptsforLock) || this.disableInput;
  }

  checkFormValid(): boolean {
    return this.voucherFrm.valid;
  }

  submit(): void {
    this.validateVoucher.emit(this.voucherKey);
  }
}
